
import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { filter, tap } from "rxjs";
import { MenuEntry, SideMenu } from "../../header/header.type";
import { User } from "@teammood/shared/util/user";
import { DialogService } from "@teammood/shared/ui/dialog";
import { TmContactUsDialogComponent } from "../contact-us/contact-us-dialog.component";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MatTooltip } from "@angular/material/tooltip";
import { MatBadge } from "@angular/material/badge";
import { HeaderService } from "../../header/header.service";
import { MAT_MENU_DEFAULT_OPTIONS, MatMenuModule } from "@angular/material/menu";

@Component({
    selector: 'top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.scss', './../side-menu/side-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
          provide: MAT_MENU_DEFAULT_OPTIONS,
          useValue: { overlayPanelClass: 'topMenuPanel' }
        }
      ],
    imports: [
        TranslateModule,
        RouterLink,
        RouterLinkActive,
        MatTooltip,
        MatMenuModule,
        MatBadge
    ]
})
export class TmTopMenuComponent implements OnInit {

    @Input() sideHeader: SideMenu;
    @Input() user: User;
    @Input() teamMoodAdminMenu: MenuEntry[];

    constructor(
        private dialogService: DialogService,
        private headerService: HeaderService,
    ) {}

    ngOnInit(): void {
        this.headerService.getTriageCount()
            .pipe(
                filter(() => !!this.sideHeader && !!this.sideHeader.respondMenu),
                tap(count => {
                    const triageMenuEntry = this.sideHeader.respondMenu.items.find(entry => entry.name === 'triage');
                    if (triageMenuEntry){
                        triageMenuEntry.counter = count;
                    }
                })
            )
            .subscribe();
    }

    protected async openContactUsDialog(){
        await this.dialogService.open(TmContactUsDialogComponent, {
            width: '100%',
            maxWidth: '490px',
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
            data: {
                user: this.user
            }
        });

    }
}